import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    aboutTheRules:
      'To get your account opened faster, make sure your document meets the following criteria:',
    checkAddressMessage:
      'The company address written on your statutes should be:\n{address}',
    title: 'Add your statutes',
  },
  fr: {
    aboutTheRules:
      'Pour que votre compte soit validé au plus vite, assurez-vous que votre document respecte le critère suivant.',
    checkAddressMessage:
      'L’adresse de l’entreprise indiquée sur vos statuts doit être\u00A0:\n{address}',
    title: 'Ajoutez vos statuts',
  },
} as const);
